module.exports = __webpack_public_path__ + "static/media/logo_sacombank.8919db63.svg";